import React from "react"
import qr from "../images/ic-qr-36.png"

export const CameraText = () => (
    <div>
        <img src={qr} width="32" height="32" className="qr-icon" alt="" />
        Scan with camera
    </div>
)
